var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-2 hidden-sm-and-down",attrs:{"outlined":""}},[_c('v-card-text',[(_vm.options)?_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.options}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }